import { Link } from 'react-router-dom';

const termsSections = [
  {
    title: 'Platform Purpose',
    body: 'Kalamanch.art is owned and operated by Tivaro LLP and helps artists, collaborators, organizers, production houses, institutions, brands, advertisers, students, learners, and clients discover and connect with creative talent and opportunities. The platform is available through website and Android app, and supports profiles, portfolio links, enquiries, private messages, Projects, Competitions, Live Auditions, workshops, classes, AI Studio tools, and admin-reviewed media.',
  },
  {
    title: 'Account Responsibility',
    body: 'Users must provide accurate information and keep login credentials secure. Do not impersonate another person, create misleading profiles, or use the platform for spam, harassment, fraud, or illegal activity.',
  },
  {
    title: 'Website and Android App Usage',
    body: 'These terms apply to all Kalamanch.art access channels, including web and Android app. Features may differ slightly by device or app version, but policy obligations remain the same.',
  },
  {
    title: 'Artist and Collaborator Profiles',
    body: 'Artists and collaborators are responsible for the accuracy of their names, categories, city, bio, images, contact details, portfolio links, and claims. Admin may verify, feature, hide, edit, or remove profiles where needed for safety or quality.',
  },
  {
    title: 'Media and Portfolio Content',
    body: 'Users must upload or link only content they own or have permission to use. Adult, pornographic, hateful, illegal, misleading, unsafe, or unrelated media is not allowed and may be removed without notice.',
  },
  {
    title: 'Projects and Work Opportunities',
    body: 'Users may post project opportunities only for genuine creative work. Project title, art form, location, budget, date, image, and details must be accurate. Projects may require admin approval before public display. Artist interest, poster review, selection, rejection, and related notifications are platform workflow tools, not a contract or payment guarantee.',
  },
  {
    title: 'Advertisers and Sponsored Promotions',
    body: 'Advertisers, sponsors, brands, institutions, and promoters are responsible for the accuracy, legality, permissions, pricing, claims, offers, dates, images, links, and deliverables in their advertisements or sponsored promotions. Kalamanch.art may review, edit, reject, pause, or remove promotions for platform quality or safety, but Tivaro LLP and Kalamanch.art do not guarantee enquiries, sales, attendance, conversions, performance, or any commercial outcome from an advertisement.',
  },
  {
    title: 'Workshops, Classes, Courses, and Enrollments',
    body: 'Artists, teachers, organizers, collaborators, or third parties who list, promote, or discuss workshops, classes, courses, training sessions, auditions, mentoring, or similar activities are solely responsible for the content, fees, schedule, venue, online links, cancellation terms, safety, quality, attendance, certificates, refunds, and delivery of those activities. Learners, students, parents, artists, and other participants must verify details directly with the organizer before enrolling or paying.',
  },
  {
    title: 'Independent Collaborations and User Dealings',
    body: 'Any collaboration, hiring, booking, teaching arrangement, class enrollment, workshop enrollment, project, performance, payment, refund, dispute, meeting, travel, contract, or offline/online dealing between artists, collaborators, advertisers, students, learners, organizers, clients, or other users is an independent arrangement between those parties. Tivaro LLP and its brand Kalamanch.art are not a party to such arrangements and have no responsibility for performance, payment, refunds, losses, damages, safety incidents, quality of work, attendance, conduct, or disputes arising from those arrangements.',
  },
  {
    title: 'User-to-User Financial Transactions',
    body: 'Any fee, advance, booking amount, commission, revenue share, sponsorship amount, class fee, workshop fee, refund, reimbursement, settlement, or other financial transaction agreed between artists, collaborators, advertisers, organizers, students, learners, clients, or other users is undertaken solely at the risk and discretion of the parties involved. Unless a transaction is expressly processed through an official Kalamanch.art payment feature, Tivaro LLP and Kalamanch.art do not collect, hold, escrow, guarantee, supervise, verify, authorize, or participate in such payments and shall not be liable for non-payment, delayed payment, chargebacks, refund disputes, fraud, misrepresentation, tax obligations, contractual breach, or any direct, indirect, incidental, consequential, or special loss arising from such user-to-user financial dealings.',
  },
  {
    title: 'Competitions and Live Auditions',
    body: 'Competitions and Live Auditions may be posted by admin or approved collaborators according to feature rules. Admin may approve, reject, edit, hide, or remove listings. Live audition links must not be used for adult, abusive, illegal, unsafe, or misleading activity. Selected participants may be shown publicly only where approved by the poster/admin workflow.',
  },
  {
    title: 'YouTube Live and Third-Party Channels',
    body: 'If a collaborator provides their own YouTube Live URL, the live audition runs on that collaborator channel and is subject to YouTube policies in addition to Kalamanch rules. If Kalamanch creates or hosts the live event through its connected channel, the event may be managed from Kalamanch admin tools.',
  },
  {
    title: 'AI Studio Responsible Use',
    body: 'AI Studio is for lawful artist growth, portfolio, promotion, event, and creative planning support. Users must not submit illegal, abusive, sexual, hateful, private, impersonation, or unsafe requests. Unsafe AI use may be blocked, logged, reviewed by admin, and may lead to restriction from AI Studio or the platform.',
  },
  {
    title: 'Enquiries and Private Message Board',
    body: 'PMB and enquiry tools are provided to support professional communication on website and app. Users should not share abusive, illegal, spam, or unsafe messages. Admin may review conversations for support, safety, moderation, and dispute handling.',
  },
  {
    title: 'User Verification and Due Diligence',
    body: 'Users are responsible for checking identity, experience, permissions, venue details, payment terms, safety arrangements, cancellation rules, and any written agreement before proceeding with a collaboration, class, workshop, advertisement, project, booking, or payment. Platform verification, badges, featured placement, profile visibility, or admin review do not replace independent due diligence by users.',
  },
  {
    title: 'Push Notifications',
    body: 'Android app users may receive push notifications for account and PMB updates when enabled. Users can manage notification preference from account controls. Delivery timing may depend on network, device settings, and operating system behavior.',
  },
  {
    title: 'Verification and Featured Status',
    body: 'Verification and featured placement are platform controls, not guarantees of employment, payment, performance quality, or commercial success. Admin may change these statuses based on profile quality and platform policy.',
  },
  {
    title: 'Payments and Paid Features',
    body: 'Some paid or premium features may be introduced, paused, changed, or removed over time. Any payment-related access may be restricted if misuse, fraud, or policy violation is detected.',
  },
  {
    title: 'No Guarantee of Work',
    body: 'Kalamanch.art helps people discover and connect, but does not guarantee work, bookings, payment, response, enrollment, attendance, student leads, advertiser leads, workshop results, class results, collaboration results, or the outcome of any conversation, project, promotion, course, class, or workshop.',
  },
  {
    title: 'Account Deletion',
    body: 'Users can request account deletion through the published deletion process at /account-deletion. Certain records may be retained where required for legal, security, fraud prevention, moderation, or dispute handling obligations.',
  },
  {
    title: 'Changes to Terms',
    body: 'We may update these terms as the platform evolves. Continued use of Kalamanch.art after updates means you accept the revised terms.',
  },
];

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-purple-50 pt-24" data-testid="terms-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#4A148C] mb-4">Platform terms</p>
          <h1 className="text-4xl sm:text-5xl font-bold gradient-text mb-6">Terms & Conditions</h1>
          <p className="text-gray-600 mb-8">Effective date: July 7, 2026</p>

          <div className="rounded-2xl bg-purple-50 p-5 text-gray-700 leading-7 mb-10">
            By using Kalamanch.art, you agree to use the platform professionally, safely, and lawfully. These terms
            apply to visitors, artists, collaborators, and admin-managed profiles using services owned and operated by
            Tivaro LLP.
          </div>

          <div className="space-y-8 text-gray-700 leading-8">
            {termsSections.map((section) => (
              <section key={section.title}>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">{section.title}</h2>
                <p>{section.body}</p>
              </section>
            ))}

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Platform Owner and Operator</h2>
              <p>
                Kalamanch.art is a platform of <span className="font-semibold">Tivaro LLP</span>. References to the
                platform owner, operator, "we", "us", or "our" in these Terms refer to Tivaro LLP where applicable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Contact</h2>
              <p>
                For terms-related enquiries, account support, profile correction, or media removal requests, contact us
                at <span className="font-semibold">me@kalamanch.art</span>.
              </p>
            </section>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link to="/privacy-policy" className="btn-primary text-center">
              Read Privacy Policy
            </Link>
            <Link to="/account-deletion" className="btn-outline text-center">
              Account Deletion
            </Link>
            <Link to="/contact" className="btn-outline text-center">
              Contact Support
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
